module.exports = __webpack_public_path__ + "static/media/de_train.5eb7f71e.svg";